import React from 'react';
import { Collapse, message, Tag, Form, Spin} from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import WeeklySchedule from '../../components/schedule/WeeklySchedule'
import AssistanceTracker from '../../components/assistances/AssistanceTracker'
import ProgressBar from '../../components/progressbar/ProgressBar'

import InlineCollapsibleForm from '../forms/InlineCollapsibleForm';
import IconInputButton from '../buttons/IconInputBtn'
import IconConfirmBtn from '../buttons/IconConfirmBtn'
import GhostTxt from '../texts/GhostTxt'
import CourseDurationTag from '../tags/CourseDurationTag'
import BasicMsg from '../messages/BasicMsg'
import ClassroomFilters from '../filters/ClassroomFilters'

import  { ADD,DELETE,USUARIO,INSTRUCTOR } from '../../utility/AppConstants'
import { TransparentColors } from '../../utility/ColorPalette';

import * as UsersActions from '../../redux/actions/UsersActions'
import * as TeacherActions from '../../redux/actions/TeacherActions'
import * as CoursesActions from '../../redux/actions/CoursesActions'
import * as AssistsActions from '../../redux/actions/AssistsActions'

import './styles/ClassroomsContainer.css'

const { Panel } = Collapse;

class ClassroomsContainer extends React.Component{
    state={ 
        enrollMessage:'',
        unenrollMessage:'',
        hoursAssigned:0,
        loading:false,
        course: this.props.course,
        originalCourse: this.props.course,
        newClassroomName: '',
    }

    componentDidUpdate(prevProps) {
    // Solo actualizamos si el curso realmente cambió
    if (prevProps.course !== this.props.course) {
        let salonesUpd
        if(this.state.originalCourse.salones!== undefined && this.props.course.salones!==undefined && (this.state.originalCourse.salones.length === this.props.course.salones.length)){
            //has not being added or removed classrooms
            salonesUpd = this.props.course.salones.filter(salon => 
                            this.state.course.salones.some(salonState => salonState.idSalon === salon.idSalon)
                        )
        }
        else{
            salonesUpd = this.props.course.salones
        }

        this.setState({
            course: {   
                ...this.props.course,
                salones: salonesUpd
            },
            originalCourse: this.props.course
        });
    }
}

     calcularHorasRegistradas = (curso) => {
        if (!curso || !Array.isArray(curso.salones)) return 0;

        return curso.salones.reduce((totalHoras, salon) => {
            if (!Array.isArray(salon.clases)) return totalHoras;

            const horasSalon = salon.clases.reduce((horas, clase) => {
                if (clase.registred && clase.horarioClase && clase.horarioClase.duracion) {
                    const duracion = parseFloat(clase.horarioClase.duracion) || 0;
                    return horas + duracion;
                }
                return horas;
            }, 0);

            return totalHoras + horasSalon;
        }, 0);
    };
    
    componentDidMount(){
        console.log('MOUNTING')
        const { course } = this.state;
        console.log('MOUNTING')
        console.log(course)

        this.props.getTeachersByCourseRequest({
            jwtToken: this.props.LoginReducer.sessionJWTToken,
            courseId: this.state.course.idCurso
        })

        if(this.props.idUserType === 2){
            this.setState({
                enrollMessage:'¿DESEAS REGISTRARTE COMO MAESTRO DE ESTA CLASE?',
                unenrollMessage:'¿DESEAS DARTE DE BAJA COMO MAESTRO DE ESTA CLASE?'
            }) 
        }
        else if(this.props.idUserType === 3){

            if (!course.salones) {
                this.setState({ loading: true});
                this.props.retrieveStudentCourseDetailsRequest({
                    jwtToken: this.props.LoginReducer.sessionJWTToken,
                    studentId: this.props.idUser,
                    courseId: this.state.course.idCurso
                })
                .then(response => {
                    console.log('--------response----------')
                    console.log(response)
                    console.log('----------------')
                    let courseUpdated = {...response.curso, vencimiento: response.vencimiento}
                    this.setState({ 
                        course: courseUpdated,
                        originalCourse: courseUpdated,
                        loading:false,
                        enrollMessage:'¿DESEAS REGISTRARTE COMO ALUMNO DE ESTA CLASE?',
                        unenrollMessage:'¿DESEAS DARTE DE BAJA DE ESTA CLASE?',
                        hoursAssigned: this.calcularHorasRegistradas(response.curso),
                    });
                })
                .catch(error => {
                    console.error("Hubo un error en retrieveStudentCourseDetailsRequest ", error);
                    this.setState({loading:false});

                });
            }
            else{
                this.setState({
                    enrollMessage:'¿DESEAS REGISTRARTE COMO ALUMNO DE ESTA CLASE?',
                    unenrollMessage:'¿DESEAS DARTE DE BAJA DE ESTA CLASE?',
                    hoursAssigned: this.calcularHorasRegistradas(this.state.course)
                }) 
            }
        }
    }

    teacherEnrollment = (detailsClass) =>{
        let idClass = detailsClass.idClase
        let jwtToken = this.props.LoginReducer.sessionJWTToken
        let idUsuario = this.props.idUser
        //VALID IF TEACHER IS OR NOT TEACHER OF THIS CLASS
        let action = detailsClass.registred
                    ? DELETE //IF YOU'RE ENROLLED, YOU WILL BE REMOVED FROM THIS CLASS
                    : ADD //IF YOU'RE NOT ENROLLED YOU WILL BE ADDED TO THIS CLASS
        
        this.props.classTeacherUpdateRequest({
            jwtToken,
            idClass,
            idUsuario,
            action
        })
    }
    openAssistanceManagement = (detailsClass) =>{
        console.log('Calling assistanceManagementModal request to open modal ')
        this.props.assistanceManagementModal({
            assistanceManagementModal: true,
            assistanceIdClass : detailsClass.idClase
        })
        console.log('Calling getClassStudentsRequest request to get class students list')
        this.props.getClassStudentsRequest({
            idClase: detailsClass.idClase,
            jwtToken: this.props.LoginReducer.sessionJWTToken
        })
        
    }

    okTeacher=(detailsClass,hoursAssigned)=>{
        if(this.props.view === USUARIO){
            this.teacherEnrollment(detailsClass)
        }else if(this.props.view === INSTRUCTOR){
            
            if(detailsClass.instructor == null || detailsClass.instructor.idUsuario !== this.props.idUser){
                message.error('NO PUEDES ACCEDER A LA INFORMACION DE ESTA CLASE, DEBIDO A QUE NO ERES INSTRUCTOR DE ELLA!')
            }else{
                this.openAssistanceManagement(detailsClass)
            }
        }
    }

    okStudent=(detailsClass,hoursAssigned)=>{
        let idCourse = detailsClass.idCourse
        let idClase = detailsClass.idClase
        let jwtToken = this.props.LoginReducer.sessionJWTToken
        let idUsuarioAlumno = this.props.idUser
        let studentHrsPerWeek= (this.props.studentLimitHrs===undefined?0:this.props.studentLimitHrs)
        let userEnable= (this.props.userEnable===undefined?false:this.props.userEnable)

        //VALID IF STUDENT IS OR NOT ENROLLED TO THIS CLASS
        let action = detailsClass.registred 
                    ? DELETE //IF YOU'RE ENROLLED, YOU WILL BE REMOVED FROM THIS CLASS
                    : ADD; //IF YOU'RE NOT ENROLLED YOU WILL BE ADDED TO THIS CLASS

        if(action === ADD && (hoursAssigned+detailsClass.classHours)>studentHrsPerWeek){
            message.error('NO PUEDES REGISTRARTE EN ESTA CLASE, HAS ALCANZADO EL LIMITE DE HORAS POR SEMANA!')
        }else if(action === ADD && !detailsClass.availability > 0){
            message.error('EL CUPO DE ESTA CLASE HA LLEGADO A SU LIMITE!')
        }else if(action === ADD && userEnable === false){
            message.error('USUARIO INACTIVO, COMUNICATE CON ADMINISTRACION PARA PODER REGISTRAR CLASES')
        }else{

            let updatedHoursAssigned = hoursAssigned
            if(action === ADD){
                updatedHoursAssigned = hoursAssigned+detailsClass.classHours
            }else if(action === DELETE){
                updatedHoursAssigned = hoursAssigned-detailsClass.classHours
            }
            
            //EXECUTED BY ADMIN
            if(this.props.LoginReducer.sessionInformation.user.userType === 1){
                console.log('action executed by admin')
                this.props.classEnrollmentRequestByAdmin({
                    jwtToken,
                    action,
                    idUsuarioAlumno,
                    idCourse,
                    idClase,
                    userType:1
                })
                .then(response => {
                    if(response.data){
                        this.updateClassInCourses(idClase, action);
                        this.setState({ hoursAssigned: updatedHoursAssigned });
                        this.props.refreshCourses({refreshCourses:true})
                    }
                })
                .catch(error => {
                    console.error("Hubo un error al inscribir al usuario", error);
                });
            }
            //EXECUTED BY STUDENT
            else if(this.props.LoginReducer.sessionInformation.user.userType === 3){
                console.log('action executed by student')
                this.props.classEnrollmentRequestByStudent({
                    jwtToken,
                    action,
                    idUsuarioAlumno,
                    idCourse,
                    idClase,
                    userType:3
                })
                .then(response => {
                    if(response.data){
                        this.updateClassInCourses(idClase, action);
                        this.setState({ hoursAssigned: updatedHoursAssigned });
                        this.props.refreshCoursesInCoursesActions({refreshCoursesInCourses: true})
                    }
                })
                .catch(error => {
                    console.error("Hubo un error al inscribir al usuario", error);
                });
            }
        }
       
    }

    updateClassInCourses = (idClase, action) => {
        const updateCourses = (course) => {
            if (!course || !Array.isArray(course.salones)) return course;

            return {
                ...course,
                salones: course.salones.map((salon) => ({
                    ...salon,
                    clases: salon.clases.map((clase) => {
                    if (clase.idClase === idClase) {
                        return {
                        ...clase,
                        registred: action === ADD,
                        availability: action === ADD
                            ? clase.availability - 1
                            : clase.availability + 1
                        };
                    }
                    return clase;
                    })
                }))
            };
        };        
        this.setState((prevState) => ({
            course: updateCourses(prevState.course),
            originalCourse: updateCourses(prevState.originalCourse)
        }));
    };
    
    handleAddClassroom = () => {
        let jwtToken = this.props.LoginReducer.sessionJWTToken
        let idCourse = this.state.course.idCurso
        const { form } = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                console.log('🎯 Valores del formulario:', values);
                console.log('🔤 Nombre del salón:', values.newClassroomName);
                console.log('🔤 maxStudents:', values.maxStudents);
                console.log('🔤 classroomColor:', values.classroomColor);
                //TODO: Add to the rerquest the missing values after alter the BD table
                this.props.addClassroomRequest({ // this is the action that we send to the server in order to enrroll an student into a class!!
                    jwtToken,
                    idCourse,
                    courseName: values.newClassroomName,
                    maxCapacity: values.maxStudents,
                    color: values.classroomColor
                })
                .then((newClassroom)=>{
                    if(newClassroom !== undefined && newClassroom !== null && newClassroom.nombre === values.newClassroomName.trim().toUpperCase()){
                        form.resetFields();
                    }
                })
                .catch(err => {
                    console.error("❌ Hubo un error al crear el salón:", err);
                });
            } 
        });
    };

    handleRemoveClassroom = (idClassroom, e) => {
        e.stopPropagation();
        let jwtToken = this.props.LoginReducer.sessionJWTToken

        console.log('eliminando pa siempre :(((())) salon:' + idClassroom)
        this.props.removeClassroomRequest({
            jwtToken,
            idClassroom
        })
    };

    handleEditarSalon = (idClassroom, classroomName, maxNumber, color) => {
        classroomName = classroomName.trim().toUpperCase();
        let jwtToken = this.props.LoginReducer.sessionJWTToken

        console.log('id:', idClassroom);
        console.log('Nuevo nombre:', classroomName);
        console.log('MaxNumber:', maxNumber);
        console.log('color:', color);

        let classroom = this.state.course.salones.find(classroom => classroom.idSalon === idClassroom);
        if(classroom !== undefined && classroom !== null){
            if(classroomName.length <= 0){
                message.warning('El nombre del salón debe de contar al menos con 1 caracter!');
            }
            else if (classroom.nombre === classroomName && classroom.maxCapacity===maxNumber &&classroom.color===color){
                message.warning('Intente modificar el salón con valores diferentes al original!');
            }
            else{
                this.props.updateClassroomRequest({
                    jwtToken,
                    idClassroom,
                    classroomName,
                    maxCapacity: maxNumber,
                    color: color
                })
            }
        }
    };

    applyFilters = ({ dias, maestros }) => {
        const { originalCourse } = this.state;
        const allClassrooms = originalCourse.salones || [];

        const filtered = allClassrooms.filter(salon => {
            const clases = salon.clases || [];

            const cumpleDia = 
            dias.length === 0 || 
            clases.some(clase => dias.includes(clase.diaClase?.dia?.toUpperCase()));

            const cumpleMaestro = 
            maestros.length === 0 || 
            clases.some(clase =>clase.instructor && maestros.includes(clase.instructor.idUsuario));

            return cumpleDia && cumpleMaestro;
        });

        /*const updatedCourse = {
            ...this.state.course,
            salones: [...filtered] // importante hacer una copia del array
        };*/

        this.setState({
            course: { ...originalCourse, salones: filtered }
        });
    }

    render(){
        const { course, loading, hoursAssigned, enrollMessage, unenrollMessage } = this.state;
        const { form, idUserType, TeacherReducer, UsersReducer, idUser, view } = this.props;

        const classrooms = course.salones || [];
        const mainColor = course.etiqueta;

        console.log('vencimiento')
        console.log(course)
        console.log(course.vencimiento)
        console.log('-------')

        const camposFormulario = [
            {
                name: 'newClassroomName',
                placeholder: 'NOMBRE DEL SALON',
                rules: [{ required: true, message: 'Introduzca un nombre para el salon' }],
                span: 24, 
                type: 'input'
            },
            {
                name: 'maxStudents',
                placeholder: 'ALUMNOS MÁXIMOS',
                rules: [{ required: true, message: 'Introduce un número' }],
                span: 9,
                type: 'numeric', // 👈 nuevo tipo
                min: 1,
                max: 6
            },
            {
                name: 'classroomColor',
                placeholder: 'COLOR DEL SALON',
                rules: [{ required: true, message: 'Seleccione un color' }],
                span: 10,
                type: 'select',
                options: TransparentColors
            }
        ];

        return(
            <Spin spinning={loading}>
                <div className='classroom-container'> 
                    
                    <InlineCollapsibleForm
                        visible={idUserType === 1}
                        form={form}
                        formTitle="CREAR SALON NUEVO" 
                        formFields={camposFormulario}
                        submitBtnText="Crear salón"
                        onSubmitAction={this.handleAddClassroom}
                    />  
                    {idUserType===3 && (
                        //CREATE COMPONENT FOR THIS WITH VISIBILITY OPTION (this.props.idUserType===3):
                        <div style={{width:'100%'}}>
                            <AssistanceTracker 
                                student={UsersReducer.userToShow} 
                                keyComponent={course.idCurso} 
                                view="UserDetails"
                            />
                            <ProgressBar 
                                progressType='CURSO' 
                                percent={course.progressPercentage} 
                                assistanceTracker={true} 
                                courseId={course.idCurso} 
                                lessons={course.temario} 
                                studentId={idUser} 
                            />

                            <Tag style={{marginBottom: '10px'}} color={mainColor}>
                                {course.vencimiento
                                    ? `Vencimiento de tu curso: ${course.vencimiento}`
                                    : 'ASISTE A TU PRIMERA CLASE!'}
                            </Tag>
                            <br/>
                        </div>
                    )}
                    
                    <CourseDurationTag
                        courseDuration={course.duracion}
                        color={mainColor}
                        className='duration-tag' 
                    />
                    <ClassroomFilters
                        teachers={TeacherReducer.teachers || []}
                        onFilterChange={this.applyFilters}
                    />
                    
                    {
                        (!classrooms || classrooms.length === 0) 
                        ?   (<BasicMsg message='Por el momento no hay salones disponibles para este curso'/>)
                        :   
                            <div style={{width:'100%'}}>
                            <h3>SALONES DISPONIBLES</h3>
                            {classrooms.map((classroom, id) => (
                                //CREATE COMPONENT FOR THIS:
                                <Collapse 
                                    key={id}
                                    expandIconPosition={'right'} 
                                    defaultActiveKey={null} 
                                    style={{
                                        backgroundColor: classroom.color ? classroom.color : mainColor, 
                                        width:'100%', 
                                        borderRadius:'8px',
                                        boxShadow:'3px 4px 4px -1px rgba(0, 0, 0, 0.5)', 
                                        marginBottom:'25px'
                                    }} 
                                >
                                    <Panel
                                        key={id}
                                        header={
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                                {idUserType===1 && ( 
                                                    <div style={{ display: 'flex', gap: '0px' }}>
                                                        <IconConfirmBtn
                                                            mainColor= 'red'
                                                            btnIcon={DeleteOutlined}
                                                            btnTitle = 'Eliminar salón'
                                                            confirmTitle={'¿ESTAS SEGURO DE ELIMINAR EL SALON ' + classroom.nombre + '?'}
                                                            onConfirmClick = {(e)=>this.handleRemoveClassroom(classroom.idSalon, e)}
                                                        />
                                                        <IconInputButton 
                                                            id={classroom.idSalon} 
                                                            btnIcon={EditOutlined}
                                                            btnTitle = 'Editar salón'
                                                            initialValue={classroom.nombre.toUpperCase()} 
                                                            initialMaxCapacity={classroom.maxCapacity} 
                                                            initialColor={classroom.color} 
                                                            onConfirm={this.handleEditarSalon}  
                                                            modalTitle='Modificar salón'
                                                            inputPlacehoder='Nombre del salon'
                                                        />
                                                    </div>
                                                )}

                                                <div
                                                    style={{
                                                        width: '100%',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <GhostTxt text={classroom.nombre.toUpperCase()} className='name-tag'/>
                                                </div>
                                            </div>
                                        }
                                    >
                                        {console.log('WeeklySchedule')}
                                        {console.log(this.state)}
                                        {console.log(course)}
                                        <WeeklySchedule
                                            view={view} 
                                            okFunction={idUserType === 2 ? this.okTeacher : this.okStudent}
                                            openAssistanceFunction={this.openAssistanceManagement}
                                            curso={course} 
                                            classroomId={classroom.idSalon}
                                            enrollToClassMsg={enrollMessage}
                                            unenrollToClassMsg={unenrollMessage}
                                            userType = {idUserType}
                                            hoursAssigned = {hoursAssigned}
                                            mainColor = {classroom.color ? classroom.color : mainColor}
                                        />
                                    </Panel>
                                </Collapse>
                            ))}
                            </div>
                    }
                </div>
            </Spin>
        );
    }
}

const mapStateToProps=(state)=>{
    return state
}

const mapDispatchToProps = {
    ...TeacherActions,
    ...UsersActions,
    ...CoursesActions,
    ...AssistsActions
};
export default connect (mapStateToProps,mapDispatchToProps)(Form.create()(ClassroomsContainer));